import React, { useState, useCallback } from 'react';

/**
 * Custom hook for modal show/hide state.
 * @returns {{ modalShowing: boolean, onCloseModal: Function, onShowModal: Function }}
 */
export const useModalState = () => {
	const [modalShowing, setModalShowing] = useState(false);
	const onCloseModal = useCallback(() => setModalShowing(false), []);
	const onShowModal = useCallback(() => setModalShowing(true), []);
	return { modalShowing, onCloseModal, onShowModal };
};

function withModalStateHandlers(WrappedComponent) {
	const WithModalStateHandlers = (props) => {
		const hookResult = useModalState();
		return (
			<WrappedComponent
				{...props}
				{...hookResult}
			/>
		);
	};
	WithModalStateHandlers.displayName = `withModalStateHandlers(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
	return WithModalStateHandlers;
}

export default withModalStateHandlers;
